import React, { useState } from "react";
import { Button } from "flowbite-react";

import "../css/HiringManager.css";

function FollowUpQuestions({
  followUpQuestions,
  updateJobDetails,
  roleName,
  isUpdating,
}) {
  const [answers, setAnswers] = useState({});

  const handleInputChange = (index, value) => {
    setAnswers({
      ...answers,
      [index]: value,
    });
  };

  const handleUpdate = () => {
    const formatedFQ = followUpQuestions
      ?.map((question, index) => {
        if (answers[index]) {
          return { question, answer: answers[index] };
        }
      })
      .filter((item) => item !== undefined);

    updateJobDetails(formatedFQ);
  };

  return (
    <div className="flex flex-col gap-1 rounded">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-h5 ml-4">Refinement Questions</h2>
        <Button
          className="text-slate-800 border border-slate-200 text-body"
          onClick={handleUpdate}
          disabled={isUpdating}
        >
          {isUpdating ? "Updating..." : "Update Job Description"}
        </Button>
      </div>
      <div className="mb-4"></div>
      <div>
        <p className="font-bold ml-4">Clarify the role details.</p>
        <p className="ml-4">
          These questions are based on details that might not have been clear in
          the original description you provided. Your answers will automatically
          update the job description on the right.
        </p>
      </div>
      {followUpQuestions?.map((question, index) => (
        <div className="bg-white mt-2 px-4 py-4 w-full" key={index}>
          <div className="text-slate-800">
            <p>{question}</p>
            <textarea
              type="text"
              value={answers[index] || ""}
              onChange={(e) => handleInputChange(index, e.target.value)}
              placeholder="Type your answer."
              className="follow-up-question-textarea bg-gray-50 rounded-md border border-slate-300 mt-4 text-black w-full"
            />
          </div>
        </div>
      ))}
    </div>
  );
}

export default FollowUpQuestions;
